import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { MainLayoutComponent } from "./layouts/main-layout/main-layout.component";
import { RouterModule } from "@angular/router";
import { AppRoutes } from "./app.routing";
import { ToastrModule } from "ng6-toastr-notifications";
import { PartialsModule } from "./partials/partials.module";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { PipesModule } from "./pipes/pipes.module";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { LangModalModule } from "./shared/modals/lang-modal/lang-modal.module";
import { SubscriptionModalModule } from "./shared/modals/subscription-modal/subscription-modal.module";
import { NavCartModule } from "./shared/components/nav-cart/nav-cart.module";
import { CheckoutLayoutComponent } from "./layouts/checkout-layout/checkout-layout.component";
import { MainHeaderComponent } from "./layouts/main-layout/components/main-header/main-header.component";

const modalModules = [LangModalModule, SubscriptionModalModule];
const LAYOUT_COMPONENTS = [MainLayoutComponent, CheckoutLayoutComponent , MainHeaderComponent];

@NgModule({
  declarations: [AppComponent, NotFoundComponent, ...LAYOUT_COMPONENTS],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NavCartModule,
    RouterModule.forRoot(AppRoutes, {
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled",
    }),
    NgxSmartModalModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot(),
    PartialsModule,
    PipesModule,
    ...modalModules,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http);
  return new TranslateHttpLoader(http, "./assets/i18n/");
}
